/* SM WORKS „In den Warenkorb“ (Thomas 04.11.2026): Die Options-App legt erst alle Aufpreise einzeln in den Warenkorb, das dauert. Der Lade-Kreis des Themes kommt sonst erst ganz am Ende, darum startet er hier direkt beim Klick.
   Er endet, wenn der Warenkorb aufgeht, eine Fehlermeldung kommt oder sich nichts tut. */
(function () {
  var knopf = null, uhr = null, start = 0, aufruf = false;
  if ('PerformanceObserver' in window) {
    new PerformanceObserver(function (l) {
      l.getEntries().forEach(function (e) { if (knopf && /\/cart\/(add|change|update)/.test(e.name)) aufruf = true; });
    }).observe({ type: 'resource' });
  }
  function pflichtFehlt() {
    return [].some.call(document.querySelectorAll('[data-bmw-fehler], .bold_option [class*="error"]'), function (e) { return e.offsetParent && e.textContent.trim(); });
  }
  function kreis(an) {
    var s = knopf.querySelector('.loading-overlay__spinner');
    knopf.classList.toggle('loading', an);
    knopf.classList.toggle('smw-laedt', an);
    if (s) s.classList.toggle('hidden', !an);
  }
  function fertig() {
    clearInterval(uhr);
    if (knopf) kreis(false);
    knopf = null;
  }
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('.product-form__submit');
    if (!k || k.disabled || k.getAttribute('aria-disabled') === 'true' || knopf) return;
    knopf = k; aufruf = false; start = Date.now();
    kreis(true);
    var fehler = k.closest('product-form') && k.closest('product-form').querySelector('.product-form__error-message-wrapper');
    uhr = setInterval(function () {
      var zeit = Date.now() - start, d = document.querySelector('cart-drawer');
      if ((d && d.classList.contains('active')) || (fehler && !fehler.hidden) || zeit > 25000) return fertig();
      if (!aufruf && ((zeit > 400 && pflichtFehlt()) || zeit > 5000)) fertig();
    }, 100);
  }, true);   // früh einhängen, die Options-App fängt den Klick sonst ab
  window.addEventListener('pageshow', fertig);
})();
